/* FC build thumbs — shows the shopper's own casket build as the line item
   image in the cart drawer and Shopping Bag. Snapshots are saved by the
   FC Casket Builder on this device (localStorage); nothing is uploaded. */
(function () {
  'use strict';
  if (window.__fcBuildThumbs) return;
  window.__fcBuildThumbs = true;

  function hasBuilds() {
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf('fcBuild:') === 0) return true;
      }
    } catch (e) { }
    return false;
  }

  function apply() {
    if (!hasBuilds()) return;
    if (!document.querySelector('.cart-item')) return;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var all = document.querySelectorAll('.cart-item');
        cart.items.forEach(function (it, i) {
          var id = it.properties && it.properties._fcBuild;
          if (!id) return;
          var data = null;
          try { data = localStorage.getItem('fcBuild:' + id); } catch (e) { }
          if (!data) return;
          var n = i + 1, rows = [];
          var byId = document.getElementById('CartDrawer-Item-' + n);
          if (byId) rows.push(byId);
          byId = document.getElementById('CartItem-' + n);
          if (byId) rows.push(byId);
          if (!rows.length && all.length === cart.items.length && all[i]) rows.push(all[i]);
          rows.forEach(function (row) {
            var img = row.querySelector('img');
            if (img && img.getAttribute('src') !== data) {
              img.removeAttribute('srcset');
              img.src = data;
            }
          });
        });
      })
      .catch(function () { });
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(apply, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
  else later();
  // the drawer swaps its own HTML after every cart change — re-apply when it does
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();
